import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withRouter from './Common/withRouter';
import { Col, Container, Row } from 'reactstrap';

const Error401 = (props) => {
    return (<>
        <React.Fragment>
            <div className="account-pages my-5 pt-5">
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div className="text-center mb-5">
                                <h1 className="display-2 fw-medium">
                                    4<i className="bx bx-buoy bx-spin text-primary display-3" />
                                    1
                                </h1>
                                <h4 className="text-uppercase">Unauthorized</h4>
                                {/* <div className="mt-5 text-center">
                                    <a
                                        className="btn btn-primary waves-effect waves-light "
                                        to="/dashboard"
                                    >
                                        Back to Dashboard
                                    </a>
                                </div> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    </>)
}

export default withRouter(Error401);